module.exports = __webpack_public_path__ + "static/harrisons-carpet-8159b2a300070a049c107967c0d892bd.jpg";